export interface ScrollToProps {
    speed?: number;
    easing?: (time: number) => number;
    callback?: () => void;
    topOffset?: number;
}

export function scrollTo(
    target: HTMLElement,
    scrollContainer: HTMLElement,
    { speed = 500, easing = SCROLL_EASING, callback = () => {}, topOffset = 0 }: ScrollToProps
) {
    const startLocation = scrollContainer.scrollTop;
    const endLocation = target.offsetTop - topOffset;
    const distance = Math.abs(endLocation - startLocation);
    const distanceMagnitude = startLocation <= endLocation ? 1 : -1;

    const start = Date.now();
    const stepFunc = () => {
        const timeLapsed = Date.now() - start;
        const percentage = Math.min(timeLapsed / speed, 1);

        const scrolledDistance = distance * easing(percentage) * distanceMagnitude;
        const position = startLocation + scrolledDistance;

        scrollContainer.scrollTop = position;
        if (position === endLocation) {
            return callback();
        }

        window.requestAnimationFrame(stepFunc);
    };

    window.requestAnimationFrame(stepFunc);
}

// acceleration until halfway, then deceleration
const SCROLL_EASING = (time: number) => (time < 0.5 ? 4 * time ** 3 : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1);
